import script from "./VideoWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoWidget.vue?vue&type=script&setup=true&lang=ts"

import "./VideoWidget.vue?vue&type=style&index=0&id=6df07ffc&scoped=true&lang=css"
import "./VideoWidget.vue?vue&type=style&index=1&id=6df07ffc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6df07ffc"]])

export default __exports__